import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Ordem } from '../../models/ordem.model';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ActivatedRoute } from '@angular/router';
import { OrdemService } from '../../services/ordem.service';
import { OrdemResolverId } from '../../resolver/ordem.resolver';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ReuniaoCanDeactivate } from '../../reuniao-can-deactivate';

@Component({
  selector: 'app-ordem-edit',
  templateUrl: './ordem-edit.component.html',
  styleUrls: ['./ordem-edit.component.scss']
})
export class OrdemEditComponent extends BaseFormComponent<Ordem> implements OnInit, ReuniaoCanDeactivate {

  id:number;
  data: Ordem;
  cancelModal:boolean = false;

  constructor(
    public activatedRoute: ActivatedRoute,
    public myService: OrdemService,
    public ordemResolverId: OrdemResolverId,
    private navigation: NavigationService,
    private cdr: ChangeDetectorRef
  ) { 
    super(activatedRoute);
  }

  canDeactivate(): boolean {
    if ( !this.cancelModal) {
      this.cancelModal = true;
      return !this.form.dirty;
    }
    else{
      return true;
    }
  }

  ngOnInit() {
    this.loading();
    this.activatedRoute.parent.paramMap.subscribe(params => {
      this.id = +params?.get('id');
    });
    this.initForm();
    this.start();
  }
  start(){
    if(this.id && this.id != 0){
      this.ordemResolverId?.getById( this.id ).subscribe({
        next: (data) => {
          var newData = data;
          this.entity = newData;
          this.data = newData;
          this.initForm();
          this.loaded();
        },
        error: (error) => {
          this.loaded();
          this.msgError(error.error.message);
        }
      })
    }
    else{
      this.loaded();
    }
  }

  initForm() {
    this.form = this.createDataFormArray();
    if (this.entity) {
      this.form.patchValue(this.entity);
    }
  }

  createDataFormArray(){
    if (!this.entity) {
      return new FormGroup({});
    }
    return new FormGroup({
      agencyPf: new FormArray(this.entity.agencyPf?.map(i => {
        return new FormGroup({
          num_codigo_pk: new FormControl(i?.num_codigo_pk),
          num_codigo_vinculado_fk: new FormControl(i?.num_codigo_vinculado_fk),
          agency_id: new FormControl(i?.agency_id),
          nro_ord:new FormControl(i?.ac_meeting_pf_agency.length > 0? i?.ac_meeting_pf_agency[0]?.nro_ord : 0),
          projectFull: this.formProjectFull(i),
          agencyPf: new FormArray(i.tb_org_orgao_many?.map(i2 => 
            new FormGroup({
              num_codigo_pk: new FormControl(i2?.num_codigo_pk),
              num_codigo_vinculado_fk: new FormControl(i2?.num_codigo_vinculado_fk),
              agency_id: new FormControl(i2?.agency_id),
              nro_ord:new FormControl(i2?.ac_meeting_pf_agency_child.length > 0? i2?.ac_meeting_pf_agency_child[0]?.nro_ord : 0),
              minutes: new FormControl(i2?.ac_meeting_pf_agency_child.length > 0? i2?.ac_meeting_pf_agency_child[0]?.minutes : null),
              projectFull: this.formProjectFull(i2)
            })
          )),
        })
      }
      ))
    })
  }

  formProjectFull(data){
    return new FormArray(data.project_full?.map(i => 
      new FormGroup({
        id:new FormControl(i.id),
        id_ord:new FormControl(i.id_ord),
        nro_ord:new FormControl(i?.ac_meeting_pf?.nro_ord ?? 0),
        pfIndicator:new FormArray( i?.pf_indicator?.map(pfi => 
          new FormGroup({
            id:new FormControl(pfi.id),
            id_ord:new FormControl(pfi.id_ord),
            nro_ord:new FormControl(pfi?.ac_meeting_pf_indicator?.nro_ord ?? 0),
            pfIndCritical:new FormArray( pfi?.pf_ind_critical?.map(pfic => 
              new FormGroup({
                id:new FormControl(pfic.id),
                id_ord:new FormControl(pfic.id_ord),
                nro_ord:new FormControl(pfic?.ac_meeting_pf_ind_critical?.nro_ord ?? 0),
                pfIndAction:new FormArray( pfic?.pf_ind_action?.map(pfia => 
                  new FormGroup({
                    id:new FormControl(pfia.id),
                    id_ord:new FormControl(pfia.id_ord),
                    nro_ord:new FormControl(pfia?.ac_meeting_pf_ind_action?.nro_ord ?? 0)
                  })) ?? []),
              })) ?? []),
            pfIndAction:new FormArray( pfi?.pf_ind_action?.map(pfia => 
              new FormGroup({
                id:new FormControl(pfia.id),
                id_ord:new FormControl(pfia.id_ord),
                nro_ord:new FormControl(pfia?.ac_meeting_pf_ind_action?.nro_ord ?? 0)
              })) ?? [])
          })) ?? []),
      })) ?? []);
  }
  getDataCreate() {
    return Object.assign({}, this.form.value);
  }

  getFormArray(fields:string[], ids:number[] = null): FormArray {
    if(this.entity){
      var item = null;
      fields.forEach((f,i)=>{
        if(!item){
          item = this.form?.get(f) as FormArray;
        }
        else{
          item = item.controls[ids[i-1]]?.get(f) as FormArray;
        }
      })
      return item;
    }
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      var newData = this.getDataCreate();
      this.myService.update(newData,this.id).subscribe({
        next: (res) => {
          this.confirmation("Ordem alterada com sucesso!").subscribe(() => {
            this.form.reset();
            window.location.reload();
          })
          this.loaded();
        },
        error: (error) => {
          this.msgError(error.error.message);
          this.loaded();
        },
      });
    }
    else {
      this.markAsDirty();
    }
  }

  voltar() {
    this.navigation.back([`reuniao/reunioes`]);
  }
  
  drop(orderValue, data, itemForm, key) {
    const previousIndex = data?.findIndex(d => d[key] === orderValue.data[key]);
    if (previousIndex !== -1) {
      moveItemInArray(data, previousIndex, orderValue.index);
      var newList = data.map((item, i) => ({'id':item[key],'nro_ord':i+1}) );
      data.forEach((item, i) => {
        const control = itemForm?.controls.find(ctrl => ctrl?.get(key)?.value === item[key]);
        control?.get('nro_ord')?.setValue(i+1);
      });
      this.cdr.detectChanges();
      itemForm.markAsDirty();
    }
  }
  
  

  //detecta o ctrl+s, evita que o navegador faça o evento padrão e chama a função de salvar
  @HostListener('document:keydown.control.s', ['$event'])
  onCtrlS(event: KeyboardEvent): void {
    event.preventDefault(); 
    this.salvar();
  }
  //detecta se o formulário está manipulado e se  pessoa está atualizando a página ou saindo dela.
  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload($event: BeforeUnloadEvent): void {
    if (this.form.dirty && !this.cancelModal) {
      event.preventDefault();
      this.cancelModal = true;
    }
  }

}
